import * as t from './actionTypes';

export const initialState = {
  fetchParams: {},
  isFetchingCollections: false,
  collections: [],
  collectionBuilder: {},
  tables: {},
};

const catalogCollectionsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    /*--------------------------------------------------------------------------------------------*/
    /* Catalog Collection Handlebars Modal Actions                                                */
    /*--------------------------------------------------------------------------------------------*/
    case t.OPEN_HANDLEBARS_MODAL:
    case t.CLOSE_HANDLEBARS_MODAL:
      return {
        ...state,
        isHandlebarsModalOpen: action.isHandlebarsModalOpen,
        selectedCollectionName: action.selectedCollectionName,
      };
    case t.SET_USES_SMART_RECOS_HANDLEBAR:
      return {
        ...state,
        usesSmartRecos: action.usesSmartRecos,
      };

    /*--------------------------------------------------------------------------------------------*/
    /* Delete Catalog Collection Actions                                                          */
    /*--------------------------------------------------------------------------------------------*/
    case t.DELETE_CATALOG_COLLECTION:
      return { ...state, isFetchingCollections: action.isFetchingCollections };
    case t.DELETE_CATALOG_COLLECTION_ERROR:
      return { ...state, error: action.error, isFetchingCollections: action.isFetchingCollections };
    case t.DELETE_CATALOG_COLLECTION_RESPONSE:
      return {
        ...state,
        isFetchingCollections: action.isFetchingCollections,
        collections: action.collections,
        total: action.total,
      };

    /*--------------------------------------------------------------------------------------------*/
    /* Delete Modal Actions                                                                       */
    /*--------------------------------------------------------------------------------------------*/
    case t.OPEN_DELETE_MODAL:
    case t.CLOSE_DELETE_MODAL:
      return {
        ...state,
        isDeleteModalOpen: action.isDeleteModalOpen,
        selectedCollection: action.selectedCollection,
      };

    /*--------------------------------------------------------------------------------------------*/
    /* Fetch Catalog Collections Actions                                                          */
    /*--------------------------------------------------------------------------------------------*/
    case t.FETCH_CATALOG_COLLECTIONS:
      return {
        ...state,
        fetchParams: action.fetchParams,
        isFetchingCollections: action.isFetchingCollections,
      };
    case t.FETCH_CATALOG_COLLECTIONS_ERROR:
      return { ...state, error: action.error, isFetchingCollections: action.isFetchingCollections };
    case t.FETCH_CATALOG_COLLECTIONS_RESPONSE:
      return {
        ...state,
        isFetchingCollections: action.isFetchingCollections,
        collections: action.collections,
        total: action.total,
      };

    default:
      return state;
  }
};

export default catalogCollectionsReducer;
